import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TExtraHash } from '../../types/analytics/page';
import { IAnalyticsState } from '../../types/analytics/state';

const initialState: IAnalyticsState = {
  page: {
    pageType: 'Newbuilding_Finder_Form',
    siteType: 'desktop',
  },
  extra: {
    cianSource: undefined,
    utmCampaign: undefined,
    utmContent: undefined,
    hash: undefined,
  },
};

export const analyticsSlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {
    setExtraHash: (state, action: PayloadAction<TExtraHash>) => {
      state.extra.hash = action.payload;
    },
  },
});

export const {
  reducer: analyticsReducer,
  actions: { setExtraHash },
} = analyticsSlice;
